
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as CustomConfig from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import { getApiData } from "Flow2/components/CustomCollections/CustomDataApi/CustomDataApi";
import { isPMDB, isTranscoder1, isMaryTv, isFrancetv, isNLW, isBetafilm, isVifogra, isSdk, isPorscheArchiv, isDZA }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';
import { getGrantingForApp, checkStatus } from "Flow2/components/CustomCollections/CustomDataControllers/CustomGrantingController";
import { getUserInfos } from "Flow2/components/CustomCollections/CustomDataControllers/CustomUserController";
import CustomSort from 'Flow2/components/CustomCollections/CustomSort/CustomSort';
import * as sTypes from 'Flow2/components/Share/ShareTypes/ShareTypes';

const getDataFromAppConfig = ({ tempConfig, flexConfig, searchObj, searchField, user, users, lg }) => {
    const items = flexConfig[searchObj] || [];
    let defaultItems = ["language", "subtitle", "purpose"];
    if (flexConfig && items && items.length) {
        let appConfigData;
        if (items.some(item => item.params && item.params[searchField])) {
            appConfigData = items.filter(item => item.params && item.params[searchField]);
        }
        else {
            if (DataUtil.isTdk()) return [];
            appConfigData = items.filter(item => defaultItems.some(el => el === item.field));
        }
        if (appConfigData && appConfigData.length) {

            let data = appConfigData.map(item => {
                let obj = getCustomWidgets({ item, name: item.field, mustChange: true, user, users, lg });
                return { name: item.field, ...obj, lgMsId: `${item.intl}` }
            });
            data.push({ inputType: "CustomCheckBox", lgMsId: "customdata.replaceSourceFileLb", name: "replacesourcefile" });
            tempConfig[0].data = data;
        }
    }
    return tempConfig;
}

const generateFromUiConfig = ({ uiConfig, configName }) => {
    if (uiConfig[configName] && uiConfig[configName].length > 0) {
        let generatedData = uiConfig[configName].map(item => {
            let obj = getCustomWidgets({ item });
            return { name: item.name, inputType: obj.inputType || null, lgMsId: `data.${item.name}` }
        });
        if (generatedData && generatedData.length > 0) return generatedData;
    }
    return false;
}

const generateFromUiConfigObj = ({ uiConfig, configName }) => {
    if (uiConfig[configName]) {
        let data = uiConfig[configName].map(item => {
            return {
                ID: item, intl: `metadata.clip.distribution.languages.dropdown.${item}`
            }
        });
        if (data && data.length > 0) return data;
    }
    return false;
}

export const checkAndUpdateConfigForApp = ({ uiConfig, tempConfig, flexConfig, user, users, lg }) => {
    if (DataUtil.isFrancetv()) {
        let newConfig = [...tempConfig];
        let newData = generateFromUiConfig({ uiConfig, configName: "tags" });
        if (newData) newConfig = newConfig.map(item => ({ ...item, data: newData }));
        let addTo = generateFromUiConfig({ uiConfig, configName: "addToMasterUpload" });
        if (addTo) newConfig = newConfig.map(item => ({ ...item, data: newData ? [...item.data, ...addTo] : addTo }));

        return addFieldsToConfigDataForApp(newConfig, flexConfig, "workflows");
    }

    tempConfig = getDataFromAppConfig({ tempConfig, flexConfig, searchObj: "mediafileItems", searchField: "masterupload", user, users, lg });

    return tempConfig;
}

export const uniqueItemsDataForApp = ({ data, property }) => {
    if (data) {
        if (property) {
            return data.reduce((acc, cur) => {
                let existingItem = acc.find(item => item[property] === cur[property])
                if (!existingItem) acc = [...acc, cur];
                return acc;
            }, []);
        }
        return data;
    }
    return [];
}

export const initObjectsForApp = (ddname, uiName, uiConfig, customDataObjects, lang) => {
    let lg = DataUtil.getLanguage(lang);
    if (isFrancetv() && uiConfig && uiConfig[uiName] && uiConfig[uiName].length >= 2) {
        let standardObj = uiConfig[uiName][0];
        if (standardObj && (standardObj.id !== undefined && standardObj.id !== "") && standardObj.name && ddname && customDataObjects)
            return {
                [`${ddname}Items`]: [{ ID: standardObj.id, [lg]: standardObj.name }],
                [`${ddname}Show`]: "none",
                [`${ddname}_apptmp`]: standardObj.id,
                //[`${ddname}_tmp`]: standardObj.name,
                customDataObjects: { ...customDataObjects, [`${ddname}`]: standardObj.id }
            }
        return false;
    }
    return false;
}

export const addFieldsToConfigDataForApp = (uploadConfig, uiConfig, uiName) => {
    let configField = { ...CustomTypes.CUSTOM_TEMPLATE_FIELD };
    let shouldAdd = false;
    if (isFrancetv() && uiConfig && uiConfig[uiName] && uiConfig[uiName].length >= 2) {
        shouldAdd = true;
        configField.name = "workflow";
        configField.lgMsId = "data.workflow";
        configField.mandatory = true;
    }
    if (shouldAdd) {
        let wfData = uiConfig[uiName].map(item => {
            if ((item.id !== undefined && item.id !== "") && item.name)
                return { ID: (item.id == 0) ? '0' : item.id, DE: item.name, EN: item.name, FR: item.name }
            return null;
        }).filter(item => item ? true : false);

        configField.data = wfData;
        return [{
            data: [configField],
            lgMsId: "data.tab.workflowdata",
            name: "workflowdata"
        }, ...uploadConfig]
    }
    return uploadConfig;
}

export const changeConfigToMWFieldsForApp = (objects, uiConfig = null, formDesign = null) => {
    if (formDesign && formDesign === CustomTypes.UPLOAD_FORM) {
        let handleArr = null;
        if (isNLW()) handleArr = [{ configfield: "containertype", mwfield: "_cliptype" }];
        if (handleArr) {
            for (let i in objects) {
                handleArr.map(item => {
                    if (i.includes(item.configfield)) {
                        let changed = item.mwfield;
                        objects[changed] = objects[i];
                        delete objects[i];
                    }
                })
            }
        }
        if (isFrancetv() && uiConfig && uiConfig.uploadWorkflows && uiConfig.uploadWorkflows.length == 1) {
            uiConfig.uploadWorkflows.forEach(item => {
                if (item.id) objects.workflow = item.id;
            })
        }
    }
    return objects
}

export const getGeneralSettingsForApp = (uiConfig) => {
    let uilanguage = {
        inputType: 'CustomStandardSelect',
        lgMsId: 'profile.languageLb',
        name: 'uilanguage',
        data: [
            { ID: "de", DE: "Deutsch", EN: "German" },
            { ID: "en", DE: "Englisch", EN: "English" }
        ]
    }
    let configData = [];
    if (uiConfig && uiConfig.languages) {
        Object.keys(uiConfig.languages).map(id => {
            configData.push({ ID: id, intl: `customdata.languages.dropdown.${id}` })
        })
    }
    if (configData.length > 0) uilanguage.data = configData;
    return [uilanguage];
}

export const getDateFormatForApp = (uiConfig) => {
    if (!isPMDB() && uiConfig && uiConfig.dateFormat) {
        let newDateFormat = uiConfig.dateFormat.toLowerCase();
        newDateFormat = newDateFormat.replace("mm", "MM");
        return newDateFormat;
    }
    return CustomTypes.DATE_FORMAT;
}

export const shouldRefreshDataForApp = (name, formDesign) => {
    if (isNLW() && (name == CustomTypes.API_PROGRAMORSERIES || name == CustomTypes.API_PARENTSERIES) && formDesign === CustomTypes.UPLOAD_FORM) {
        return true;
    }
    return false;
}

export const isNewEntryForApp = (obj, formDesign) => {
    if (isNLW() || isFrancetv() || isPorscheArchiv()) {
        if (obj && obj.length === 0 && formDesign === CustomTypes.UPLOAD_FORM)
            return true;
        return false;
    }
    return false;
}

export const refreshApiContentForApp = (ddname, propsData) => {
    if (!isPMDB() && propsData && propsData.customAppData) {
        if (propsData.customAppData[ddname]) return true;
    }

    return false;
}

export const getApiDataForApp = (propsId, propsName, storeObjects, lg, name) => {
    if (storeObjects && storeObjects[name] && storeObjects[name].length > 0)
        return storeObjects[name].map(item => {
            if (isNLW()) {
                let gui_type = '';
                if (item["type"] === CustomTypes.MW_SERIES_PROGRAM) gui_type = CustomTypes.GUI_SERIES_PROGRAM;
                if (item["type"] === CustomTypes.MW_SERIES_SERIES) gui_type = CustomTypes.GUI_SERIES_SERIES;
                if (item["type"] === CustomTypes.MW_SERIES_SEASON) gui_type = CustomTypes.GUI_SERIES_SEASON;
                if (item["type"]) {
                    let titleAndType = "ID:" + item["id"] + " TITLE: " + item[propsName] + " TYPE: " + gui_type;
                    return ({ ID: item[propsId], DE: titleAndType, EN: titleAndType, RU: titleAndType, FR: titleAndType, CY: titleAndType });
                }

                let idAndTitle = "ID:" + item["id"] + " -- TITLE: " + item[propsName];
                return ({ ID: item[propsId], DE: idAndTitle, EN: idAndTitle, RU: idAndTitle, FR: idAndTitle, CY: idAndTitle });
            }
            return ({ ID: item[propsId], DE: item[propsName], EN: item[propsName], RU: item[propsName], FR: item[propsName] });
        })
            .sort(DataUtil.dynamicSortAndIgnoreCase(lg));

    return [];
}

export const changeFormStyleForApp = (formDesign) => {
    if ((isPMDB() || isTranscoder1() || isMaryTv()) && (formDesign === CustomTypes.UPLOAD_FORM)) {
        return true;
    }
    return false;
}

export const getLeftCountForApp = (formConfig) => {
    if (isPMDB() || (formConfig && formConfig.length <= 2)) return 1;
    if (isTranscoder1()) return 3;
    if (isPorscheArchiv()) return 3;
    return 2;
}

export const getFormTabs = (formData) => {
    let tabs = [];
    formData.map(item => {
        if (item.type === "tab") tabs.push({ "name": item.name, "lgMsId": item.name })
    })
    return tabs;
}

const checkAndSetEmptyItem = (options) => {
    if (options) {
        options = options.filter(item => item.trim() != "=" && item.trim() != "0=");
        options = ["CustomFakeId=...", ...options];
    }
    return options;
}

const checkRole = ({ data, entry, user }) => {
    let newData = data;
    if (user && entry && entry.params && entry.params.filter && entry.params.filter.props
        && entry.params.filter.props.user && entry.params.filter.props.user.role) {
        if (entry.params.filter.props.user.role[user.role]) {
            let roleData = entry.params.filter.props.user.role[user.role];
            newData = data.filter(el => roleData.find(r => r == el.ID));
        }
    }
    return newData;
}

const convertOptionsToData = ({ options, field, user = null, entry, showEmptyItem = true, isClassic = false }) => {
    let data = [];
    let EN = null;
    let intl = false;
    if (Array.isArray(options) && options.length > 0) {
        if (showEmptyItem) options = checkAndSetEmptyItem(options);
        options.map((item, index) => {
            let ID = DataUtil.subStringBefore(item, "=");
            let DE = DataUtil.subStringAfter(item, "=");
            EN = DE;
            if (isPMDB() && ID !== 'CustomFakeId' && entry && entry.intl) {
                intl = `${entry.intl}.dropdown.${ID}`;
            }
            if (ID && DE) {
                let retObj = { ID, DE, EN, RU: EN, FR: EN, CY: EN, intl };
                if (getGrantingForApp({ user: user, field: field, grantingField: ID })) {
                    if (field === "purpose" && ID !== "CustomFakeId") retObj.customorder = index + 1;
                    if (field === "subtitle" && !ID.startsWith("stl")) retObj.ID = "stl" + ID;
                }
                //if (checkStatus({ user: user, field: field, checkField: ID })) {
                data.push(retObj);
                //}
            }
        })
        if (isPorscheArchiv() || isPMDB()) data = data.filter(el => el.ID !== 'CustomFakeId');
        if (isClassic) {
            data = data.map(item => ({ name: item.ID, value: item.EN, intl: `${entry.intl}.dropdown.${item.ID}` }))
        }
    }
    if (isPMDB()) data = checkRole({ data, entry, user });
    return data;
}

export const convertMetaDataForClipInfo = (data) => {
    let customClipInfo = [];
    try {
        Object.keys(data).map(item => {
            if (data[item].field && ((CustomTypes.APP_CLIPID_FIELDS.indexOf(data[item].field) !== -1)
                || (CustomTypes.APP_CREATED_FIELDS.indexOf(data[item].field) !== -1)
                || (CustomTypes.APP_PROD_DATE_FIELDS.indexOf(data[item].field) !== -1))) {

                customClipInfo.push(data[item].field)
            }
        })
    } catch (e) {
        console.log("LAMTEST getClipInfoForApp");
    }
    return customClipInfo;
}

const isCondition = (item, formName, submenu) => {
    if (isNLW()) if (item.tab === submenu && !item[formName] && item.params.condition) return true;
    if (item.tab === submenu && !item[formName] && item.params && item.params.mandatory_upload && item.params.condition) return true;
    return false;
}

const getCondition = (item, formName, submenu) => {
    let condition = { name: "customdisplay", value: "customdisplay", ext: { name: "customdisplay", value: "customdisplay" } };
    if (item.tab === submenu && !item[formName] && item.params && (item.params.mandatory_upload || isNLW()) && item.params.condition) {
        for (let i in item.params.condition) {
            condition.name = i;
            condition.value = item.params.condition[i];
            condition.required = item.params.mandatory_upload ? item.params.mandatory_upload : false;
            if (item.params.conditionext) {
                for (let j in item.params.conditionext) {
                    condition.ext = { name: j, value: item.params.conditionext[j] }
                }
            }
        }
    }
    return condition;
}

const getConfigParams = ({ item, config }) => {
    if (config && config.length && item && item.params) {
        let configdata = null;
        config.forEach(el => {
            let newEl = item.params[el];
            if (newEl) configdata = { ...configdata, [el]: newEl };
        });
        return configdata;
    }
    return null;
}

const changeInputType = (item, formName, name) => {
    let widget = { inputType: "CustomDataInput", data: null };

    if (isNLW() && formName === CustomTypes.APP_FORM_UPLOAD && (name === CustomTypes.API_SERIES_PARENT
        || name === CustomTypes.API_PROGRAMORSERIES || name === CustomTypes.API_PARENTSERIES)) {
        widget.inputType = "CustomDropDown";
        widget.data = [];
    }
    if (isNLW() && formName === CustomTypes.APP_FORM_SEARCH && name === "production_date") {
        widget.inputType = "CustomDateGroup";
    }
    if (item.params.datefield && formName === CustomTypes.APP_FORM_SEARCH) {
        widget.inputType = "CustomDateGroup";
    }
    if (item.params.datefield && formName === CustomTypes.APP_FORM_UPLOAD)
        widget.inputType = "CustomDateBox";
    if (name.includes("description"))
        widget.inputType = "CustomResizableTextArea";

    return widget;
}

const changeCheckBoxType = ({ item, formName, name, user, mustChange }) => {
    let widget = { inputType: "CustomCheckBox", data: null };
    if ((((formName === CustomTypes.APP_FORM_UPLOAD || formName === CustomTypes.APP_FORM_SEARCH) && (isFrancetv() || isNLW()))) || mustChange) {
        widget.inputType = "CustomDropdownWithFadeBox";
        widget.data = convertOptionsToData({ options: item.options, field: name, user, entry: item });
    }
    return widget;
}

const isMandatory = (item, formName, submenu) => {
    if (item.tab === submenu && item[formName] === true && item.params && item.params.mandatory_upload && formName === CustomTypes.APP_FORM_UPLOAD)
        return true;
    if (item.upload && item.upload.tab && item.upload.tab === submenu && item.upload.required && formName === CustomTypes.APP_FORM_UPLOAD)
        return true;
}

export const getCustomWidgets = ({ item, formName, name, submenu, user, mustChange, users, lg }) => {
    let widget;
    let tmpType;

    // Implemented tmpItem because changes on item changes the config in the store
    // Example: item.type = item[formName].customtype; Line: 391
    const tmpItem = { ...item };

    if (tmpItem && tmpItem[formName] && tmpItem[formName].customobj) {
        widget = CustomConfig.customObj[`${tmpItem[formName].customobj}`];
        return widget;
    }
    if (tmpItem && tmpItem[formName] && tmpItem[formName].customtype) {
        tmpItem.type = tmpItem[formName].customtype;
        // console.log(item, tmpItem);
    }

    tmpType = tmpItem.type;
    if (tmpItem.params && tmpItem.params.form_type) tmpType = tmpItem.params.form_type;
    if (formName !== CustomTypes.APP_FORM_UPLOAD && tmpType == 'flexdate') tmpType = 'dategroup';
    switch (tmpType) {
        case 'text':
        case 'internallink':
            widget = changeInputType(tmpItem, formName, name);
            return widget;
        case 'tagtree':
        case 'flexlist':
            widget = { inputType: "CustomDropdownWithFadeBox", data: [] }
            return widget;
        case 'textfield':
            widget = { inputType: "CustomResizableTextArea" };
            return widget;
        case 'classicDD':
            return { inputType: "CustomClassicDropdown", data: convertOptionsToData({ options: tmpItem.options, field: name, user, entry: tmpItem, isClassic: true }) };
        case 'flexWindow':
            return { inputType: "CustomDataInputWithBtn", data: null }
        case 'dropdown':
            widget = { inputType: "CustomDropDown", data: convertOptionsToData({ options: tmpItem.options, field: name, user, entry: tmpItem }) };
            return widget;
        case 'addlist':
        case 'multiselect':
            widget = { inputType: "CustomDropdownWithFadeBox", data: convertOptionsToData({ options: tmpItem.options, field: name, user, entry: tmpItem }) };
            return widget;
        case 'userlist':
        case 'userslist':
            //widget = { inputType: "CustomDropdownWithFadeBox", data: getUserInfos(users, lg, "id") }
            const data = getUserInfos({ storeObj: users, lg, property: "id", configItem: item });
            widget = { inputType: "CustomDropdownWithFadeBox", data }
            return widget;
        case 'contentlist':
        case 'yearlist':
        case 'countrylist':
            widget = { inputType: "CustomDropdownWithFadeBox", data: [] }
            return widget;
        case 'checkbox':
            widget = changeCheckBoxType({ item: tmpItem, formName, name, submenu, user, mustChange });
            return widget;
        case 'datetime':
            widget = { inputType: "CustomDateTimeGroup" };
            return widget;
        case 'checkboxlist':
            return { inputType: "CustomCheckBoxList", data: convertOptionsToData({ options: tmpItem.options, field: name, user, entry: tmpItem, showEmptyItem: false }) }
        case 'timegroup':
            return { inputType: "CustomTimeGroup", nameIn: name, nameOut: tmpItem[formName].groupwith ? tmpItem[formName].groupwith : "" }
        case 'flexdate':
            return { inputType: "CustomFlexDateGroup", data: null };
        case 'dategroup':
            return { inputType: "CustomDateGroup" };
        case 'number':
            return { inputType: "CustomDataInput", data: null, isNum: true };
        case 'datefromto':
            //return { inputType: "CustomDateBox" };
            return { inputType: "CustomDateGroup" };
        default:
            return { inputType: "CustomDataInput", data: null };
    }
}

export const findSubMenuData4Form = ({ formName, formData, submenu, user = null, users, lg }) => {
    let submenuData = [];
    formData.map(item => {
        if ((item.tab === submenu && item[formName]) || isCondition(item, formName, submenu)
            || (item[formName] && item[formName].tab && item[formName].tab === submenu)) {
            let inputType, widget;
            let name = item.field;
            let data = null;
            let api = false;
            let convertedObj = null;
            let mandatory = isMandatory(item, formName, submenu);
            let condition = getCondition(item, formName, submenu);
            let minMaxDate = getConfigParams({ item, config: ["minDate", "maxDate"] });
            widget = getCustomWidgets({ item, formName, name, submenu, user, users, lg });
            let lgMsId = item.intl;
            let advanced = item.params && item.params.advanced ? item.params.advanced : null;
            if (widget) {
                inputType = widget.inputType ? widget.inputType : null;
                data = widget.data ? widget.data : null;
                if (widget.lgMsId) lgMsId = widget.lgMsId
            }
            if (item && item[formName] && item[formName].customtype && widget.lgMsId) lgMsId = widget.lgMsId;
            if (data || api) convertedObj = { inputType, lgMsId, name, data, api, mandatory, condition, advanced };
            else convertedObj = { inputType, lgMsId, name, mandatory, condition, advanced };

            if (minMaxDate) convertedObj = { ...convertedObj, ...minMaxDate };
            if (item[formName] && item[formName].order) convertedObj = { ...convertedObj, [[formName]]: item[formName] };
            if (item[formName] && item[formName].groupwith) convertedObj = { ...convertedObj, ...widget, lgMsId: `${lgMsId}Out` };
            if (item.type && item.type === 'number') {
                if (item.params && item.params.elementConfig) {
                    convertedObj.addObj = item.params.elementConfig;
                    convertedObj.addObj.pattern = "[0-9]*";
                }
                convertedObj.isNum = true;
            }
            if (convertedObj) submenuData.push(convertedObj);
        }
    })
    return submenuData;
}

export const addSubmenu4Form = (submenu) => {
    switch (submenu.lgMsId) {
        case 'metadata.tab.history':
            return { "name": "videoDetails", "lgMsId": "data.tab.videoDetails", "data": submenu.data };
        default:
            return submenu;
    }
}

export const makeSubDialog = (item, formConfig, formName, tabName, subMenuData) => {
    if (formConfig && formConfig.length > 0) {
        if (formName === CustomTypes.APP_FORM_UPLOAD && item.name === tabName) {
            subMenuData.push({ inputType: "CustomMessageBox", lgMsId: "customdata.selectContentMsg" });
            let subItemSection = [{ inputType: "CustomSubFormSection", name: "appSubForm", data: subMenuData }];
            let subItem = { inputType: "CustomSubForm", lgMsId: tabName, data: subItemSection };
            return formConfig.map(tab => {
                if (tab.name === "masterdata") {
                    let newItem = { ...tab }
                    newItem.data.push(subItem);
                    return newItem;
                }
                return tab;
            });
        }
    }
    return formConfig;
}

export const fetchApiDataForApp = (name, props, lg, data) => {
    // let data;
    if (!isPMDB()) {
        switch (name) {
            case CustomTypes.API_PROJECT:
                data = DataUtil.setInitialObjState("id", "name", props.projects, lg);
                break;
            case CustomTypes.API_ROOM:
                data = DataUtil.setInitialObjState("id", "title", props.rooms, lg);
                break;
            case CustomTypes.API_DISTRIBUTION:
                data = DataUtil.setInitialObjState("id", "name", props.distributions, lg);
                break;
            case CustomTypes.API_PARENTSERIES:
            case CustomTypes.API_SERIES_PARENT:
            case CustomTypes.API_PROGRAMORSERIES:
                if (isNLW())
                    data = getApiDataForApp("id", "seriestitle", props.customAppData, lg, name);
                break;
            case CustomTypes.API_TAGS:
                if (isPorscheArchiv()) {
                    if (props.flexTags && props.flexTags.length) data = [...props.flexTags];
                    else data = [];
                    //else props.getFlexTags();
                }
                break;
        }
    }

    return data;
}


export const setupApiDataForDropDown = (name, data, props) => {
    let lg = DataUtil.getLanguage(props.lg);
    if (isPMDB()) {
        switch (name) {
            case CustomTypes.API_CONTENTS:
                data = CustomConfig.CONTENT_DATA;
                break;
            case CustomTypes.API_MODELS:
                data = getApiData(props[`api${name}`], `${name}`);
                //data = uniqueItemsDataForApp({ data, property: "DE" });
                break;
            case CustomTypes.API_TAGS:
                if (props && props.formDesign === CustomTypes.SEARCH_FORM && DataUtil.isPMDB()) {
                    data = getApiData(props[`api${name}`], `${name}`, true).sort(DataUtil.dynamicSortAndIgnoreCase(lg));
                } else {
                    data = getApiData(props[`api${name}`], `${name}`).sort(DataUtil.dynamicSortAndIgnoreCase(lg));
                }
                data = uniqueItemsDataForApp({ data, property: "DE" });
                break;
            case CustomTypes.API_YEAR:
                data = DataUtil.getModelYears() || [];
                break;
            case CustomTypes.API_COUNTRIES:
                data = CustomConfig.countriesArr;
                break;
            case CustomTypes.API_PMDBUSER:
            case CustomTypes.API_CREATEDBY:
            case CustomTypes.API_MODIFIEDBY:
                //data = getUserInfos(props.uploaders, lg, "id");
                data = getUserInfos({ storeObj: props.uploaders, lg, property: "id" });
                break;
            case CustomTypes.API_PROJECT:
                data = DataUtil.setInitialLevelObj({ lg, tree: props.projectTree });
                if (!data || !data.length) props.loadProjectTree();
                break;
            case CustomTypes.API_ROOM:
                data = DataUtil.setInitialObjState("id", "title", props.rooms, lg);
                if (!data || !data.length) props.loadRooms();
                break;
            case CustomTypes.API_DISTRIBUTION:
                data = DataUtil.setInitialObjState("id", "name", props.distributions, lg);
                break;
            //EVENTROOM
            case CustomTypes.API_EVENTROOM:
                data = DataUtil.setInitialObjState("id", "name", props.eventrooms, lg);
                if (!data || !data.length) props.loadEventRoomTree();
                break;
            case CustomTypes.API_DIST_LANG:
                data = generateFromUiConfigObj({ uiConfig: props.uiConfig, configName: "DISTRIBUTION_LANGUAGES" });
                break;
        }
        return data;
    }
    return fetchApiDataForApp(name, props, lg, data);
}

const createTabData = ({ formName, formData, user, tab, users, lg }) => {
    let tabData = [];
    tabData = findSubMenuData4Form({ formName, formData, submenu: tab, user, users, lg });
    let sortObjects = { data: tabData, sorted: "asc", field: "order", childObj: formName, isNumber: true };
    tabData = CustomSort.sortByValue(sortObjects);
    return tabData;
}

const addRightsToTab = ({ tabData, formName, formData, user }) => {
    tabData.push(CustomConfig.customrights);
    let tempSection = createTabData({ formName, formData, user, tab: CustomTypes.RIGHTS_NOTEMP });
    let localSection = createTabData({ formName, formData, user, tab: CustomTypes.RIGHTS_NOLOCAL });
    let mediaSection = createTabData({ formName, formData, user, tab: CustomTypes.RIGHTS_NOMEDIA });
    let subRightsForm = [{ inputType: 'CustomSubFormSection', name: CustomTypes.RIGHTS_NOTEMP, data: tempSection },
    { inputType: 'CustomSubFormSection', name: CustomTypes.RIGHTS_NOLOCAL, data: localSection },
    { inputType: 'CustomSubFormSection', name: CustomTypes.RIGHTS_NOMEDIA, data: mediaSection }];
    tabData.push({ inputType: "CustomSubForm", lgMsId: "data.vRightsDefinitionResLb", data: subRightsForm, maintab: "rights" });
    return tabData;
}

const initFormDataForPMDb = ({ formName, formData, user }) => {
    let formConfig = [];
    let masterData = createTabData({ formName, formData, user, tab: "masterdata" });
    let advancedData = createTabData({ formName, formData, user, tab: "advanceddata" });
    let videodetails = createTabData({ formName, formData, user, tab: "videodetails" });
    let production = createTabData({ formName, formData, user, tab: "production" });
    if (formName === CustomTypes.APP_FORM_UPLOAD) masterData = addRightsToTab({ tabData: masterData, formName, formData, user });
    formConfig.push(addSubmenu4Form({ "name": "metaData", "lgMsId": "customdata.metadatDataLb", "data": masterData }));
    formConfig.push(addSubmenu4Form({ "name": "advancedData", "lgMsId": "customdata.advancedDataLb", "data": advancedData }));
    formConfig.push(addSubmenu4Form({ "name": "videoDetails", "lgMsId": "customdata.videoDetailsLb", "data": videodetails }));
    if (formName === CustomTypes.APP_FORM_SEARCH) {
        let distribution = createTabData({ formName, formData, user, tab: "distribution" });
        formConfig.push(addSubmenu4Form({ "name": "distribution", "lgMsId": "customdata.distributionLb", "data": distribution }));
    }

    if (formName === CustomTypes.APP_FORM_UPLOAD) {
        formConfig.push(addSubmenu4Form({ "name": "productionData", "lgMsId": "customdata.ProductionLb", "data": production }));
        //formConfig.push(addSubmenu4Form({ "name": "addToData", "lgMsId": "upload.addToLb", "data": CustomConfig.uploadAddTo }));
        //EVENTROOM
        formConfig.push(addSubmenu4Form({ "name": "addToData", "lgMsId": "upload.addToLb", "data": CustomConfig.uploadAddToAdvanced }));
    }
    return formConfig;
}

export const initFormDataForApp = ({ formName, formData, formTabs, user = null, users, lg }) => {
    let formConfig = [];
    if (isPMDB() && CustomTypes.FLEX_APP) {
        formConfig = initFormDataForPMDb({ formName, formData, user });
    } else {
        if (Array.isArray(formTabs) && formTabs.length > 0) {
            formTabs.map(item => {
                let subMenuData = findSubMenuData4Form({ formName, formData, submenu: item.name, user, users, lg });
                let searchTab = "metadata.tab.reference";
                if (Array.isArray(subMenuData) && subMenuData.length > 0) {
                    let submenuName = DataUtil.subStringAfter(item.name, "metadata.tab.");
                    if (isNLW() && formName === CustomTypes.APP_FORM_UPLOAD && item.name === searchTab) {
                        formConfig = makeSubDialog(item, formConfig, formName, searchTab, subMenuData);
                    }
                    else
                        formConfig.push(addSubmenu4Form({ name: submenuName, "lgMsId": item.name, "data": subMenuData }));
                }
            })
        }
        if (!isPMDB()) {
            if (formName === CustomTypes.APP_FORM_UPLOAD) {
                let data = CustomConfig.uploadAddTo;
                if (isPorscheArchiv()) data = CustomConfig.uploadAddTo_pa;
                if (isBetafilm()) data = CustomConfig.uploadAddToForApps;
                if (!isVifogra() && !isSdk()) formConfig.push(addSubmenu4Form({ "name": "addToData", "lgMsId": "upload.addToLb", "data": data }));
            }
        }
    }
    return formConfig;
}
